import { useAuth } from '@opendoor/auth-fe/context';
import { useQuery } from '@tanstack/react-query';
import { requestZeusFromBrowser } from 'components/api/zeusBrowserClient';
import type { HubPurchaseOffersQuery } from 'components/buyer/__generated__/purchase-offers.zeus';
import { HubPurchaseOffersDocument } from 'components/buyer/__generated__/purchase-offers.zeus';

export type HubBuyingOffer = HubPurchaseOffersQuery['customerAccount']['buyer']['offers'][number];

export function useHubPurchaseOffers() {
  const { authentication } = useAuth();
  const customerUuid =
    authentication.state === 'authenticated' ? authentication.user.customerUuid : null;
  return useQuery({
    queryKey: ['hub', 'purchase-offers', customerUuid],
    enabled: customerUuid !== null,
    meta: { captureErrorContext: 'HubPurchaseOffers' },
    queryFn: async ({ signal }) => {
      const result = await requestZeusFromBrowser(HubPurchaseOffersDocument, {}, signal);
      return result.customerAccount.buyer.offers;
    },
  });
}
